import { z } from 'zod';
import { userRoleSchema } from '../roles.js';
import { paginationQuerySchema } from '../pagination.js';
import { emailSchema, passwordSchema } from './auth.js';
const displayNameSchema = z
    .string({ required_error: 'Nom affiché requis' })
    .trim()
    .min(2, 'Le nom affiche doit contenir au moins 2 caractères')
    .max(120, 'Le nom affiche ne doit pas dépasser 120 caractères');
export const userSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string(),
    role: userRoleSchema,
    isActive: z.boolean(),
    mustChangePassword: z.boolean(),
    createdAt: z.string(),
});
export const createUserSchema = z.object({
    email: emailSchema,
    displayName: displayNameSchema,
    role: userRoleSchema,
    password: passwordSchema,
    isActive: z.boolean().default(true),
    mustChangePassword: z.boolean().default(true),
});
export const updateUserSchema = z
    .object({
    email: emailSchema.optional(),
    displayName: displayNameSchema.optional(),
    role: userRoleSchema.optional(),
    isActive: z.boolean().optional(),
    mustChangePassword: z.boolean().optional(),
    password: passwordSchema.optional(),
})
    .refine((value) => Object.values(value).some((field) => field !== undefined), {
    message: 'Aucune modification fournie',
});
export const listUsersQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(120).optional(),
    role: userRoleSchema.optional(),
    isActive: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((value) => (typeof value === 'boolean' ? value : value === 'true'))
        .optional(),
});
//# sourceMappingURL=user.js.map